import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import Header from "./Header";

export default function Home() {
  const [patients, setPatients] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);

  const [patient, setPatient] = useState({
    id: "",
    name: "",
    age: "",
    sex: "",
    mobile: "",
    dc_complan_1: "",
    dc_complan_2: "",
    dc_complan_3: "",
    dc_complan_4: "",
    dc_complan_5: "",
    dc_complan_6: "",
    pastHistory: "",
    familyHistory: "",
    motherHistory: "",
    personalHistory: "",
    heatCold: "",
    sweat: "",
    bath: "",
    airFan: "",
    app: "",
    thirst: "",
    desire: "",
    aversion: "",
    aqq: "",
    stool: "",
    urine: "",
    sleep: "",
    dream: "",
    menses: "",
    leue: "",
    mind: "",

    entries: [],
  });

  useEffect(() => {
    fetchPatients();
  }, []);

  const fetchPatients = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/patients`);
      setPatients(response.data);
      setFilteredPatients(response.data);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  // Check if a value is meaningfully filled
  const isFilled = (v) => {
    if (v === null || v === undefined) return false;
    const s = String(v);
    return s.trim() !== "";
  };

  // Sidebar badge helpers for Step 3 and Step 4
  const isHistoryTabFilled = (key) => {
    if (key === 'past') return isFilled(patient.pastHistory);
    if (key === 'family') return isFilled(patient.familyHistory);
    if (key === 'mother') return isFilled(patient.motherHistory);
    if (key === 'personal') return isFilled(patient.personalHistory);
    return false;
  };
  const getGeneralBadge = (key) => {
    if (key === 'records') return (patient.entries && patient.entries.length) || 0;
    return isFilled(patient[key]) ? 1 : 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPatient({ ...patient, [name]: value });
  };

  // Save New Patient
  const savePatient = async (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/addProduct`,
        { ...patient },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert("Save The Patients");
      fetchPatients();
      setIsOpen(false); 
       setFormStep(0); 
      resetForm();
    } catch (error) {
      alert(error);
    }
  };

  // Edit Patient (Load existing medical entries)
  const editPatient = (data) => {
    setPatient({
      id: data.id,
      name: data.name,
      age: data.age,
      sex: data.sex,
      mobile: data.mobile,
      dc_complan_1: data.dc_complan_1,
      dc_complan_2: data.dc_complan_2,
      dc_complan_3: data.dc_complan_3,
      dc_complan_4: data.dc_complan_4,
      dc_complan_5: data.dc_complan_5,
      dc_complan_6: data.dc_complan_6,
      pastHistory: data.pastHistory,
      familyHistory: data.familyHistory,
      motherHistory: data.motherHistory,
      personalHistory: data.personalHistory,
      heatCold: data.heatCold,
      sweat: data.sweat,
      bath: data.bath,
      airFan: data.airFan,
      app: data.app,
      thirst: data.thirst,
      desire: data.desire,
      aversion: data.aversion,
      aqq: data.aqq,
      stool: data.stool,
      urine: data.urine,
      sleep: data.sleep,
      dream: data.dream,
      menses: data.menses,
      leue: data.leue,
      mind: data.mind,

      entries: data.entries || [],
    });
  };

  // Update Patient
  const updatePatient = async (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    try {
      const patientData = { ...patient, entries: [...patient.entries] };
      await axios.put(
        `${API_BASE_URL}/api/updatepatients/${patient.id}`,
        patientData
      );
      alert("Patient updated successfully!");
      fetchPatients();
      resetForm();
       setFormStep(0);
      setIsOpen(false); 
    } catch (error) {
      console.error("Error updating patient:", error);
      alert("Failed to update patient");
    }
  };

  // Only allow saving on the last step. Enter key on earlier steps should NOT save.
  const handleSubmit = (e) => {
    e.preventDefault();
    // If not on last step, just attempt to go next with validation
    if (formStep < 3) {
      handleNext();
      return;
    }
    // On last step via Enter key: do NOT auto-save. Require explicit click on Save.
    return;
  };

  // Explicit save handler for the Save button click only
  const handleSave = () => {
    const v = validateStep(3);
    if (Object.keys(v).length > 0) {
      setErrors(v);
      return;
    }
    setErrors({});
    if (patient.id) {
      updatePatient();
    } else {
      savePatient();
    }
  };

  // Delete Patient
  const deletePatient = async (id) => {
    if (!window.confirm("Are you sure you want to delete this patient?"))
      return;
    try {
      await axios.delete(`${API_BASE_URL}/api/patients/${id}`);
      alert("Patient deleted successfully!");
      fetchPatients();
    } catch (error) {
      console.error("Error deleting patient:", error);
      alert("Failed to delete patient");
    }
  };

  // Handle search dynamically
  useEffect(() => {
    if (search.trim() === "") {
      setFilteredPatients([]); // Show nothing when no search is active
    } else {
      setFilteredPatients(
        patients.filter((p) =>
          (p.name || "").toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [search, patients]);
  // Reset Form
  const resetForm = () => {
    setPatient({
      id: "",
      name: "",
      age: "",
      sex: "",
      mobile: "",
      dc_complan_1: "",
      dc_complan_2: "",
      dc_complan_3: "",
      dc_complan_4: "",
      dc_complan_5: "",
      dc_complan_6: "",
      pastHistory: "",
      familyHistory: "",
      motherHistory: "",
      personalHistory: "",
      heatCold: "",
      sweat: "",
      bath: "",
      airFan: "",
      app: "",
      thirst: "",
      desire: "",
      aversion: "",
      aqq: "",
      stool: "",
      urine: "",
      sleep: "",
      dream: "",
      menses: "",
      leue: "",
      mind: "",
      entries: [],
    });
  };

  const addDateMedRemark = () => {
    setPatient((prevPatient) => ({
      ...prevPatient,
      entries: [
        ...prevPatient.entries,
        { date: "", medicines: "", remark: "" },
      ],
    }));
  };
  const handleDateMedRemarkChange = (index, field, value) => {
    const updatedEntries = [...patient.entries];
    updatedEntries[index][field] = value;
    setPatient({ ...patient, entries: updatedEntries });
  };

  // const PatientFormPopup = ({
  //   patient,
  //   handleChange,
  //   savePatient,
  //   updatePatient,
  //   addDateMedRemark,
  //   handleDateMedRemarkChange,
  // }) => {
  //   const [isOpen, setIsOpen] = useState(false);
  // };
  const [isOpen, setIsOpen] = useState();
  const [formStep, setFormStep] = useState(0); // 0: Personal, 1: Complaints, 2: History, 3: Generals + Records
  const [complaintsCount, setComplaintsCount] = useState(1);
  const [historyTab, setHistoryTab] = useState("past"); // past, family, mother, personal
  const [generalTab, setGeneralTab] = useState("general"); // general, records
  const [generalSubTab, setGeneralSubTab] = useState("heatCold"); // individual general fields
  const [errors, setErrors] = useState({});

  // Auto-resize textarea helpers
  const handleAutoResize = (e) => {
    const el = e.target;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  };
  const autoResizeAll = () => {
    // Defer to allow DOM to paint first
    setTimeout(() => {
      document.querySelectorAll("textarea.autogrow").forEach((el) => {
        el.style.height = "auto";
        el.style.height = `${el.scrollHeight}px`;
      });
    }, 0);
  };

  useEffect(() => {
    if (isOpen) autoResizeAll();
  }, [isOpen, formStep, patient]);

  // Validate fields for the current step
  const validateStep = (step) => {
    const errs = {};
    if (step === 0) {
      if (!patient.name || String(patient.name).trim() === "") {
        errs.name = "Name is required";
      }
      if (patient.age === "" || patient.age === null) {
        errs.age = "Age is required";
      }
      if (!patient.sex) {
        errs.sex = "Sex is required";
      }
      if (!patient.mobile || String(patient.mobile).trim() === "") {
        errs.mobile = "Mobile number is required";
      }
    }
    if (step === 1) {
      const values = [
        patient.dc_complan_1,
        patient.dc_complan_2,
        patient.dc_complan_3,
        patient.dc_complan_4,
        patient.dc_complan_5,
        patient.dc_complan_6,
      ];
      const hasAny = values.some((v) => v && String(v).trim() !== "");
      if (!hasAny) {
        errs.complaints = "Enter at least one complaint";
      }
    }
    // Step 2 (History) optional by default; add rules if needed
    // Step 3 (General symptoms & Records) can be optional as well; add rules if needed
    return errs;
  };

  const handleNext = () => {
    const v = validateStep(formStep);
    if (Object.keys(v).length > 0) {
      setErrors(v);
      return;
    }
    setErrors({});
    setFormStep((s) => Math.min(3, s + 1));
  };

  // Derive number of complaint fields to show from current patient values
  useEffect(() => {
    const values = [
      patient.dc_complan_1,
      patient.dc_complan_2,
      patient.dc_complan_3,
      patient.dc_complan_4,
      patient.dc_complan_5,
      patient.dc_complan_6,
    ];
    let maxIdx = 0;
    values.forEach((v, idx) => {
      if (v && String(v).trim() !== "") maxIdx = idx + 1;
    });
    setComplaintsCount(Math.max(1, maxIdx));
  }, [patient.dc_complan_1, patient.dc_complan_2, patient.dc_complan_3, patient.dc_complan_4, patient.dc_complan_5, patient.dc_complan_6]);

  const addComplaint = () => setComplaintsCount((c) => Math.min(6, c + 1));
  const removeComplaint = () => {
    setComplaintsCount((c) => {
      if (c <= 1) return 1;
      const key = `dc_complan_${c}`;
      setPatient((prev) => ({ ...prev, [key]: "" }));
      return c - 1;
    });
  };

  return (
    <>
      <Header />
      <div className="papatient-details">
        <div className="container">
          <button onClick={() => setIsOpen(true)}>Add Patients Here</button>
          {isOpen && (
            <div className="modal-overlay">
              <div className="modal-content">
                <button
                  className="close-button"
                  onClick={() => setIsOpen(false)}
                >
                  X
                </button>
                <div className="patient-form">
                  <div className="wizard-topbar">
                    <div className="title">
                      {formStep === 0 && "Personal details"}
                      {formStep === 1 && "Chief complaints"}
                      {formStep === 2 && "History"}
                      {formStep === 3 && "General symptoms & Records"}
                    </div>
                  </div>
                  <div className="wizard-stepper">
                    {[0, 1, 2, 3].map((i) => (
                      <div
                        key={i}
                        className={`dot ${i <= formStep ? "active" : ""}`}
                      ></div>
                    ))}
                  </div>

                  <form
                    onSubmit={handleSubmit}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                  >
                    <div className="wizard-body">
                    {formStep === 0 && (
                      <div>
                        <label>
                          <span>Name:</span>
                          <input
                            className={errors.name ? 'input-error' : ''}
                            type="text"
                            name="name"
                            placeholder="Enter full name"
                            aria-label="Name"
                            value={patient.name}
                            onChange={handleChange}
                          />

                        </label>
                        {errors.name && (
                          <div className="error" role="alert">{errors.name}</div>
                        )}
                        <label>
                          <span>Age:</span>
                          <input
                            className={errors.age ? 'input-error' : ''}
                            type="number"
                            name="age"
                            placeholder="Enter age"
                            aria-label="Age"
                            value={patient.age}
                            onChange={handleChange}
                          />

                        </label>
                        {errors.age && (
                          <div className="error" role="alert">{errors.age}</div>
                        )}
                        <label>
                          <span>Sex:</span>
                          <select
                            className={errors.sex ? 'input-error' : ''}
                            name="sex"
                            aria-label="Sex"
                            onChange={handleChange}
                            value={patient.sex}
                          >
                            <option value="">Select sex</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                          </select>
                        </label>
                        {errors.sex && (
                          <div className="error" role="alert">{errors.sex}</div>
                        )}
                        <label>
                          <span>Mobile No:</span>
                          <input
                            className={errors.mobile ? 'input-error' : ''}
                            type="text"
                            name="mobile"
                            placeholder="Enter mobile number"
                            aria-label="Mobile number"
                            value={patient.mobile}
                            onChange={handleChange}
                          />
                        </label>
                        {errors.mobile && (
                          <div className="error" role="alert">{errors.mobile}</div>
                        )}
                      </div>
                    )}

                    {formStep === 1 && (
                      <div>
                        {errors.complaints && (
                          <div className="error" role="alert">{errors.complaints}</div>
                        )}
                        {[...Array(complaintsCount)].map((_, idx) => {
                          const i = idx + 1;
                          const name = `dc_complan_${i}`;
                          return (
                            <label key={name}>
                              <span>{`D/C ${i} Complan:`}</span>
                              <textarea
                                className={`autogrow ${errors.complaints ? 'input-error' : ''}`}
                                name={name}
                                placeholder={`Enter complaint ${i}`}
                                aria-label={`Complaint ${i}`}
                                value={patient[name]}
                                onChange={(e) => {
                                  handleChange(e);
                                  handleAutoResize(e);
                                }}
                                onInput={handleAutoResize}
                              />
                            </label>
                          );
                        })}
                        <div className="inline-actions">
                          <button
                            type="button"
                            className="btn pill ghost"
                            onClick={removeComplaint}
                            disabled={complaintsCount <= 1}
                          >
                            Remove complaint
                          </button>
                          <button
                            type="button"
                            className="btn pill primary"
                            onClick={addComplaint}
                            disabled={complaintsCount >= 6}
                          >
                            Add complaint
                          </button>
                        </div>
                      </div>
                    )}

                    {formStep === 2 && (
                      <div className="general-layout">
                        <div className="general-sidebar">
                          {[
                            { key: 'past', label: 'Past' },
                            { key: 'family', label: 'Family' },
                            { key: 'mother', label: 'Mother' },
                            { key: 'personal', label: 'Personal' },
                          ].map(({key, label}) => (
                            <button
                              key={key}
                              type="button"
                              className={`side-tab ${historyTab === key ? 'active' : ''}`}
                              onClick={() => setHistoryTab(key)}
                            >
                              <span>{label}</span>
                              {isHistoryTabFilled(key) && (
                                <span className="count-badge" aria-label="filled">•</span>
                              )}
                            </button>
                          ))}
                        </div>
                        <div className="general-content">
                          {historyTab === "past" && (
                            <label>
                              <span>Past History:</span>
                              <textarea
                                className="autogrow"
                                name="pastHistory"
                                placeholder="Enter past history"
                                aria-label="Past history"
                                value={patient.pastHistory}
                                onChange={(e) => {
                                  handleChange(e);
                                  handleAutoResize(e);
                                }}
                                onInput={handleAutoResize}
                              />
                            </label>
                          )}
                          {historyTab === "family" && (
                            <label>
                              <span>Family History :</span>
                              <textarea
                                className="autogrow"
                                name="familyHistory"
                                placeholder="Enter family history"
                                aria-label="Family history"
                                value={patient.familyHistory}
                                onChange={(e) => {
                                  handleChange(e);
                                  handleAutoResize(e);
                                }}
                                onInput={handleAutoResize}
                              />
                            </label>
                          )}
                          {historyTab === "mother" && (
                            <label>
                              <span>Mother History:</span>
                              <textarea
                                className="autogrow"
                                name="motherHistory"
                                placeholder="Enter mother history"
                                aria-label="Mother history"
                                value={patient.motherHistory}
                                onChange={(e) => {
                                  handleChange(e);
                                  handleAutoResize(e);
                                }}
                                onInput={handleAutoResize}
                              />
                            </label>
                          )}
                          {historyTab === "personal" && (
                            <label>
                              <span>Personal History:</span>
                              <textarea
                                className="autogrow"
                                name="personalHistory"
                                placeholder="Enter personal history"
                                aria-label="Personal history"
                                value={patient.personalHistory}
                                onChange={(e) => {
                                  handleChange(e);
                                  handleAutoResize(e);
                                }}
                                onInput={handleAutoResize}
                              />
                            </label>
                          )}
                        </div>
                      </div>
                    )}

                    {formStep === 3 && (
                      <div>
                        <div className="tabs">
                          <button
                            type="button"
                            className={`tab ${generalTab === "general" ? "active" : ""}`}
                            onClick={() => setGeneralTab("general")}
                          >
                            General
                          </button>
                          <button
                            type="button"
                            className={`tab ${generalTab === "records" ? "active" : ""}`}
                            onClick={() => setGeneralTab("records")}
                          >
                            Records
                          </button>
                        </div>

                        {generalTab === "general" && (
                          <div className="general-layout">
                            <div className="general-sidebar">
                              {[
                                { key: 'records', label: 'Records' },
                                { key: 'heatCold', label: 'Heat Cold' },
                                { key: 'sweat', label: 'Sweat' },
                                { key: 'bath', label: 'Bath' },
                                { key: 'airFan', label: 'Air Fan' },
                                { key: 'app', label: 'Appetite' },
                                { key: 'thirst', label: 'Thirst' },
                                { key: 'desire', label: 'Desire' },
                                { key: 'aversion', label: 'Aversion' },
                                { key: 'aqq', label: 'AQQ' },
                                { key: 'stool', label: 'Stool' },
                                { key: 'urine', label: 'Urine' },
                                { key: 'sleep', label: 'Sleep' },
                                { key: 'dream', label: 'Dream' },
                                { key: 'menses', label: 'Menses' },
                                { key: 'leue', label: 'Leucorrhoea' },
                                { key: 'mind', label: 'Mind' },
                              ].map(({key, label}) => (
                                <button
                                  key={key}
                                  type="button"
                                  className={`side-tab ${generalSubTab === key ? 'active' : ''}`}
                                  onClick={() => setGeneralSubTab(key)}
                                >
                                  <span>{label}</span>
                                  {getGeneralBadge(key) > 0 && (
                                    <span className="count-badge" aria-label="has data">{key === 'records' ? getGeneralBadge(key) : '•'}</span>
                                  )}
                                </button>
                              ))}
                            </div>
                            <div className="general-content">
                              {(() => {
                                const map = {
                                  heatCold: { label: 'Heat Cold:', name: 'heatCold', placeholder: 'Describe heat/cold', aria: 'Heat cold' },
                                  sweat: { label: 'Sweat:', name: 'sweat', placeholder: 'Describe sweat', aria: 'Sweat' },
                                  bath: { label: 'Bath:', name: 'bath', placeholder: 'Describe bath', aria: 'Bath' },
                                  airFan: { label: 'Air Fan:', name: 'airFan', placeholder: 'Describe air/fan', aria: 'Air fan' },
                                  app: { label: 'App:', name: 'app', placeholder: 'Describe appetite', aria: 'Appetite' },
                                  thirst: { label: 'Thirst:', name: 'thirst', placeholder: 'Describe thirst', aria: 'Thirst' },
                                  desire: { label: 'Desire:', name: 'desire', placeholder: 'Describe desires', aria: 'Desire' },
                                  aversion: { label: 'Aversion:', name: 'aversion', placeholder: 'Describe aversions', aria: 'Aversion' },
                                  aqq: { label: 'Aqq:', name: 'aqq', placeholder: 'Describe AQQ', aria: 'AQQ' },
                                  stool: { label: 'Stool:', name: 'stool', placeholder: 'Describe stool', aria: 'Stool' },
                                  urine: { label: 'Urine:', name: 'urine', placeholder: 'Describe urine', aria: 'Urine' },
                                  sleep: { label: 'Sleep:', name: 'sleep', placeholder: 'Describe sleep', aria: 'Sleep' },
                                  dream: { label: 'Dream:', name: 'dream', placeholder: 'Describe dreams', aria: 'Dream' },
                                  menses: { label: 'Menses:', name: 'menses', placeholder: 'Describe menses', aria: 'Menses' },
                                  leue: { label: 'Leue:', name: 'leue', placeholder: 'Describe leucorrhoea', aria: 'Leucorrhoea' },
                                  mind: { label: 'Mind:', name: 'mind', placeholder: 'Describe mental state', aria: 'Mind' },
                                };
                                const cfg = map[generalSubTab] || map.heatCold;
                                return (
                                  <label>
                                    <span>{cfg.label}</span>
                                    <textarea
                                      className="autogrow"
                                      name={cfg.name}
                                      placeholder={cfg.placeholder}
                                      aria-label={cfg.aria}
                                      value={patient[cfg.name]}
                                      onChange={(e) => {
                                        handleChange(e);
                                        handleAutoResize(e);
                                      }}
                                      onInput={handleAutoResize}
                                    />
                                  </label>
                                );
                              })()}
                            </div>
                          </div>
                        )}

                        {generalTab === "records" && (
                          <>
                            <h4>Date, Medicines, and Remarks</h4>
                            {patient.entries.map((entry, index) => (
                              <div key={index}>
                                <label>
                                  <span>Date:</span>
                                  <input
                                    type="date"
                                    aria-label="Record date"
                                    value={entry.date}
                                    onChange={(e) =>
                                      handleDateMedRemarkChange(
                                        index,
                                        "date",
                                        e.target.value
                                      )
                                    }
                                  />
                                </label>
                                <label>
                                  <span>Medicines:</span>
                                  <input
                                    type="text"
                                    placeholder="Enter medicines"
                                    aria-label="Medicines"
                                    value={entry.medicines}
                                    onChange={(e) =>
                                      handleDateMedRemarkChange(
                                        index,
                                        "medicines",
                                        e.target.value
                                      )
                                    }
                                  />
                                </label>
                                <label>
                                  <span>Remark:</span>
                                  <input
                                    type="text"
                                    placeholder="Enter remark"
                                    aria-label="Remark"
                                    value={entry.remark}
                                    onChange={(e) =>
                                      handleDateMedRemarkChange(
                                        index,
                                        "remark",
                                        e.target.value
                                      )
                                    }
                                  />
                                </label>
                              </div>
                            ))}
                            <button type="button" onClick={addDateMedRemark}>
                              Add Entry
                            </button>
                          </>
                        )}
                      </div>
                    )}

                    </div>
                    <div className="actions-bottom">
                      <button
                        type="button"
                        className="btn pill ghost"
                        onClick={() => setFormStep((s) => Math.max(0, s - 1))}
                        disabled={formStep === 0}
                      >
                        Back
                      </button>
                      {formStep < 3 ? (
                        <button
                          type="button"
                          className="btn pill primary"
                          onClick={handleNext}
                        >
                          Next page
                        </button>
                      ) : (
                        <button type="button" className="btn pill primary" onClick={handleSave}>
                          {patient.id ? "Update Patient" : "Save Patient"}
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          <div className="patient-form">
            <h3>Patients & Medical Records</h3>
            <div className="patient-search">
              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="patient-list">
              <div className="patient-card">
                {filteredPatients.map((patient) => (
                  <div key={patient.id}>
                    {isFilled(patient.name) && (
                      <label>
                        <strong>Name:</strong> {patient.name}
                      </label>
                    )}
                    {isFilled(patient.age) && (
                      <label>
                        <strong>Age:</strong> {patient.age}
                      </label>
                    )}
                    {isFilled(patient.sex) && (
                      <label>
                        <strong>Sex:</strong> {patient.sex}
                      </label>
                    )}
                    {isFilled(patient.mobile) && (
                      <label>
                        <strong>Mobile No:</strong> {patient.mobile}
                      </label>
                    )}
                    {isFilled(patient.dc_complan_1) && (
                      <label>
                        <strong>D/C 1 Complan:</strong> {patient.dc_complan_1}
                      </label>
                    )}
                    {isFilled(patient.dc_complan_2) && (
                      <label>
                        <strong>D/C 2 Complan:</strong> {patient.dc_complan_2}
                      </label>
                    )}
                    {isFilled(patient.dc_complan_3) && (
                      <label>
                        <strong>D/C 3 Complan:</strong> {patient.dc_complan_3}
                      </label>
                    )}
                    {isFilled(patient.dc_complan_4) && (
                      <label>
                        <strong>D/C 4 Complan:</strong> {patient.dc_complan_4}
                      </label>
                    )}
                    {isFilled(patient.dc_complan_5) && (
                      <label>
                        <strong>D/C 5 Complan:</strong> {patient.dc_complan_5}
                      </label>
                    )}
                    {isFilled(patient.dc_complan_6) && (
                      <label>
                        <strong>D/C 6 Complan:</strong> {patient.dc_complan_6}
                      </label>
                    )}
                    {isFilled(patient.pastHistory) && (
                      <label>
                        <strong>Past History:</strong> {patient.pastHistory}
                      </label>
                    )}
                    {isFilled(patient.familyHistory) && (
                      <label>
                        <strong>Family History:</strong> {patient.familyHistory}
                      </label>
                    )}
                    {isFilled(patient.motherHistory) && (
                      <label>
                        <strong>Mother History:</strong> {patient.motherHistory}
                      </label>
                    )}
                    {isFilled(patient.personalHistory) && (
                      <label>
                        <strong>Personal History:</strong> {patient.personalHistory}
                      </label>
                    )}
                    {isFilled(patient.heatCold) && (
                      <label>
                        <strong>Heat Cold:</strong> {patient.heatCold}
                      </label>
                    )}
                    {isFilled(patient.sweat) && (
                      <label>
                        <strong>Sweat:</strong> {patient.sweat}
                      </label>
                    )}
                    {isFilled(patient.bath) && (
                      <label>
                        <strong>Bath:</strong> {patient.bath}
                      </label>
                    )}
                    {isFilled(patient.airFan) && (
                      <label>
                        <strong>Air Fan:</strong> {patient.airFan}
                      </label>
                    )}
                    {isFilled(patient.app) && (
                      <label>
                        <strong>App:</strong> {patient.app}
                      </label>
                    )}
                    {isFilled(patient.thirst) && (
                      <label>
                        <strong>Thirst:</strong> {patient.thirst}
                      </label>
                    )}
                    {isFilled(patient.desire) && (
                      <label>
                        <strong>Desire:</strong> {patient.desire}
                      </label>
                    )}
                    {isFilled(patient.aversion) && (
                      <label>
                        <strong>Aversion:</strong> {patient.aversion}
                      </label>
                    )}
                    {isFilled(patient.aqq) && (
                      <label>
                        <strong>Aqq:</strong> {patient.aqq}
                      </label>
                    )}
                    {isFilled(patient.stool) && (
                      <label>
                        <strong>Stool:</strong> {patient.stool}
                      </label>
                    )}
                    {isFilled(patient.urine) && (
                      <label>
                        <strong>Urine:</strong> {patient.urine}
                      </label>
                    )}
                    {isFilled(patient.sleep) && (
                      <label>
                        <strong>Sleep:</strong> {patient.sleep}
                      </label>
                    )}
                    {isFilled(patient.dream) && (
                      <label>
                        <strong>Dream:</strong> {patient.dream}
                      </label>
                    )}
                    {isFilled(patient.menses) && (
                      <label>
                        <strong>Menses:</strong> {patient.menses}
                      </label>
                    )}
                    {isFilled(patient.leue) && (
                      <label>
                        <strong>Leue:</strong> {patient.leue}
                      </label>
                    )}
                    {isFilled(patient.mind) && (
                      <label>
                        <strong>Mind:</strong> {patient.mind}
                      </label>
                    )}
                    {isFilled(patient.file_path) && (
                      <label>
                        <strong>Upload Picture:</strong> {patient.file_path}
                      </label>
                    )}

                    {patient.entries && patient.entries.length > 0 ? (
                      <ul>
                        {patient.entries.map((e, index) => (
                          <li
                            key={`${patient.id}-${index}`}
                            style={{
                              marginBottom: "10px",
                              borderBottom: "1px solid #ddd",
                              paddingBottom: "5px",
                            }}
                          >
                            <p>
                              <strong>Date:</strong> {e.date}
                            </p>
                            {e.medicines && (
                              <p>
                                <strong>Medicines:</strong> <span className="med-badge">{e.medicines}</span>
                              </p>
                            )}
                            {e.remark && (
                              <p>
                                <strong>Remark:</strong> {e.remark}
                              </p>
                            )}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>No medical records</p>
                    )}

                    <br></br>
                    {/* <button onClick={() => editPatient(patient)}>Edit</button> */}
                    <button
                      onClick={() => {
                        editPatient(patient);
                        setIsOpen(true);
                      }}
                    >
                      Edit
                    </button>
                    <button onClick={() => deletePatient(patient.id)}>
                      Delete
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Header />
    </>
  );
}
